import { Mask } from 'maska'

const PHONE_MASK = '(###) ###-####'
const FEIN_MASK = '##-#######'
const DATE_MASK = '##/##/####'
/**
      label="Anticipated Premium"
      v-model="internalForm.insuranceInfo.estPremium"
      prefix="$"
      v-maska="estPremiumMask"
      :data-maska="MONEY_MASK"
      data-maska-tokens="9:[0-9]:repeated"
      data-maska-reversed
 */
const MONEY_MASK = '9,99#'

function formatPhoneForDisplay(unmaskedPhone) {
  if (!unmaskedPhone) {
    return unmaskedPhone
  }
  const mask = new Mask({ mask: PHONE_MASK })

  return mask.masked(unmaskedPhone)
}
export { PHONE_MASK, FEIN_MASK, DATE_MASK, formatPhoneForDisplay, MONEY_MASK }
